import { createAction } from '@ngrx/store';

import { DashboardClaimV2 } from './claim-v2-dashboard.models';

export enum ClaimDashboardActionTypes {
  LOAD_CLAIM_V2_DASHBOARD = '[ClaimDashboard] Load Dashboard Claims V2',
  LOAD_CLAIM_V2_DASHBOARD_SUCCESS = '[ClaimDashboard] Load Dashboard Claims V2 Success',
  LOAD_CLAIM_V2_DASHBOARD_FAIL = '[ClaimDashboard] Load Dashboard Claims V2 Error'
}

export const LoadClaimV2Dashboard = createAction(ClaimDashboardActionTypes.LOAD_CLAIM_V2_DASHBOARD);

export const LoadClaimV2DashboardSuccess = createAction(
  ClaimDashboardActionTypes.LOAD_CLAIM_V2_DASHBOARD_SUCCESS,
  (payload: DashboardClaimV2[]) => ({
    payload
  })
);

export const LoadClaimV2DashboardFail = createAction(
  ClaimDashboardActionTypes.LOAD_CLAIM_V2_DASHBOARD_FAIL,
  (payload: unknown) => ({
    //error
    payload
  })
);

export type ClaimDashboardAction =
  | ReturnType<typeof LoadClaimV2Dashboard>
  | ReturnType<typeof LoadClaimV2DashboardSuccess>
  | ReturnType<typeof LoadClaimV2DashboardFail>;
